import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders, HttpResponse} from "@angular/common/http";
import {Observable} from "rxjs";
import {FormGroup} from "@angular/forms";

@Injectable({
  providedIn: 'root'
})
export class NotificheService {

  public results: any;
  portaleNotificheURL: string;
  numNotifiche!: number;

  constructor(private httpClient: HttpClient) {
    this.portaleNotificheURL = "services/portalenotifiche/api"
  }

  ricercaNotificheUtente(form: any): Observable<HttpResponse<any>> {
    let url = "services/portalenotifiche/api/notificas?";
    if (form.size != null) {
      url += `size=${JSON.stringify(form.size)}&`;
    }
    if (form.page != null) {
      url += `page=${JSON.stringify(form.page)}&`;
    }
    if (url.endsWith('&')) {
      url = url.slice(0, -1);
    }
    return this.httpClient.get<any>(url, {observe: 'response'});
  }


  ricaercaCanali(): Observable<any> {
    return this.httpClient.get<any>("services/portalenotifiche/api/preferenze");
  }

  cambioPreferenzaON(codice: string): Observable<any> {
    return this.httpClient.post<string>("services/portalenotifiche/api/inserimentoPreferenzaCanale", codice)
  }

  cambioPreferenzaOFF(codice: string): Observable<any> {
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      body: codice  // Passa il codice come corpo della richiesta
    };
    return this.httpClient.delete<string>("services/portalenotifiche/api/rimozionePreferenzaCanale", options)
  }

  contaNotifiche(): Observable<number> {
    return this.httpClient.get<number>("services/portalenotifiche/api/notificheNonLette");
  }

  aggiornaNotifiche(): void {
    this.contaNotifiche().subscribe({
      next: (res) => {
        this.numNotifiche = res;
      }
    })
  }

  markAsRead(form: FormGroup): Observable<any> {
    return this.httpClient.post<any>(this.portaleNotificheURL + '/notifica/cambioStato', form)
  }
}
